<template>
  <div :class="sectionClass" v-if="context.item.modulinfobildtext2spaltiguntertitel1">
    <div class="container">
      <template v-for="i in 3" :key="i">
        <article class="img-text-teaser" v-if="getField('modulinfobildtext2spaltiguntertitel' + i)">
          <h2 class="img-text-teaser__title section-title">
            <span class="headline" v-html="getField('modulinfobildtext2spaltiguntertitel' + i)">
            </span>
          </h2>
          <div class="row">
            <div class="column column-40">
              <a
                :href="getField('modulinfobildtext2spaltigbutton' + i).url"
                :target="getField('modulinfobildtext2spaltigbutton' + i).target"
              >
                <img
                  class="img-text-teaser__img"
                  :src="getField('modulinfobildtext2spaltigbild' + i).url"
                  :alt="getField('modulinfobildtext2spaltigbild' + i).alt"
                />
              </a>
            </div>
            <div class="column img-text-teaser__text">
              <span v-html="getField('modulinfobildtext2spaltigtext' + i)"></span>

              <a
                v-if="getField('modulinfobildtext2spaltigbutton' + i).url"
                :href="getField('modulinfobildtext2spaltigbutton' + i).url"
                :target="getField('modulinfobildtext2spaltigbutton' + i).target"
                class="button button--cat1"
                v-html="getField('modulinfobildtext2spaltigbutton' + i).text"
              >
              </a>
            </div>
          </div>
        </article>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModulInfoBildText2Spaltig',
  props: {
    context: {
      type: Object,
    },
  },
  computed: {
    sectionClass: function () {
      if (this.context.item.modulinfobildtext2spaltigstyle != '')
        return 'outer info-lr section-styling-' + this.context.item.modulinfobildtext2spaltigstyle;
      return 'outer info-lr section-styling-0';
    },
  },
  methods: {
    getField(field) {
      const fullPath = `${field}`;
      return this.context.item[fullPath] || '';
    },
  },
};
</script>
